export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        blockModifiers: ['minTopPadding'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                text1: '<div style="border: none; background-color: #FEF2CD; color: #86680F; font-size: 14px; padding: 15px; border-radius: 10px; margin-top: 10px; width: fit-content !important;"><strong>Order related questions?</strong><br>Please see the <a style="text-decoration: underline;" href="/ordersupport">order support page</a></div>',
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['noMargin'],
                headerSize: 'large',
                header1: 'Hello!<br>Let\'s grab a fika* and talk about friction-free commerce.',
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                text1: 'Or send us an email:<br><a href="mailto:info@spotin.com?subject=Contact from website" style="text-decoration:underline">info@spotin.com</a>',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                text1: '<strong>Main office</strong><br>Spotin AB<br>Rådstugatan 7A<br>972 38 Luleå<br>Sweden<br><br>',
                text2: '<strong>Marketing & Sales</strong><br>Spotin AB<br>Stureplan 6, 3rd floor<br>114 35 Stockholm<br>Sweden'
              }
            }
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'blueOnSand',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                text1: '* Swedish for coffee and bisquits',
              }
            },
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Contact.js